module.exports = __webpack_public_path__ + "img/wl_slider1.7990f858.jpg";